import { AbstractParser } from "../../parser";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { Beneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/beneficiary";
import { parseBeneficiary } from "./beneficiary-parse-functions";

export class FindBeneficiariesByFiscalNumberParser extends AbstractParser<PageableResult> {
  parse(payload: any): PageableResult {
    const pageableResult = new PageableResult();
    pageableResult.setStart(payload.Start);
    pageableResult.setEnd(payload.TotalPerPages);
    pageableResult.setTotalItems(payload.Total);

    let beneficiaries: Beneficiary[] = payload.Data.map((beneficiaryItem) => {
      return parseBeneficiary(beneficiaryItem);
    });

    pageableResult.setItems(beneficiaries);
    return pageableResult;
  }
}
